export default "__VITE_PUBLIC_ASSET__34748a76__"